var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 32,
    viewBox: "0 0 40 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3",
    y: 9,
    width: 4,
    height: 14,
    rx: 2,
    fill: "#FD6F20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 7",
    width: 4,
    height: 14,
    rx: 2,
    transform: "matrix(-1 0 0 1 40 9)",
    fill: "#FD6F20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4",
    x: 6,
    y: 6,
    width: 4,
    height: 20,
    rx: 2,
    fill: "#FD6F20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 8",
    width: 4,
    height: 20,
    rx: 2,
    transform: "matrix(-1 0 0 1 34 6)",
    fill: "#FD6F20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 5",
    x: 12,
    y: 3,
    width: 4,
    height: 26,
    rx: 2,
    fill: "#FD6F20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 9",
    width: 4,
    height: 26,
    rx: 2,
    transform: "matrix(-1 0 0 1 28 3)",
    fill: "#FD6F20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 6",
    x: 18,
    width: 4,
    height: 32,
    rx: 2,
    fill: "#FD6F20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 204",
    x: 6,
    y: 14,
    width: 28,
    height: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 205",
    x: 19,
    y: 20,
    width: 2,
    height: 2,
    fill: "#D9D9D9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.14297bb53a45e8131a33f5ddc07cc001.svg";
export { ForwardRef as ReactComponent };